<template>
  <div class="col-12">
    <p>
      We recommend you to remove this app from battery optimization for more reliable reminders and notifications.
    </p>
    <card class="rounded">
      <div class="col-11" style="padding: 0px;">
        <p style="margin-bottom: 0px;font-size: 1.1em;font-weight: 600;line-height: 1.5em;">Removed from battery optimization</p>
        <p style="line-height: 1.5em;margin-bottom: 0px;font-size: 0.8em;">Battery optimization can interfere with reminders and notifications</p>
      </div>
      <div class="col-1" style="padding: 0px;text-align: end;">
        <i class="fas fa-check-circle" v-if="batteryOptimizationRemoved" style="color: var(--green);font-size: 2em;"></i>
        <i class="fas fa-times-circle" v-else style="color: var(--red);font-size: 2em;"></i>
      </div>
    </card>
    <div style="width:100%;text-align:center;margin-top:5em">
      <n-button round type="primary" simple size="md" @click.native="openSettings" class="d-md-none cancel-appt-request-button" v-if="batteryOptimizationRemoved">
        Open battery optimization settings
      </n-button>
      <n-button round v-else type="primary" size="md" @click.native="remove" class="d-md-none cancel-appt-request-button">
        Remove
      </n-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      batteryOptimizationRemoved: false,
      checkBatteryOptimizationInterval: null,
    };
  },
  mounted() {
    this.checkBatteryOptimization();
    this.checkBatteryOptimizationInterval = setInterval(
      this.checkBatteryOptimization,
      2500
    );
  },
  beforeDestroy() {
    clearInterval(this.checkBatteryOptimizationInterval);
  },
  methods: {
    openSettings() {
      cordova.plugins.PowerOptimization.RequestOptimizationsMenu().then(
        (result) => {
          console.log("ok");
        },
        (err) => {
          console.error(err);
        }
      );
    },
    remove() {
      cordova.plugins.PowerOptimization.RequestOptimizations().then(
        (result) => {
          console.log("ok");
        },
        (err) => {
          console.error(err);
        }
      );
    },
    checkBatteryOptimization() {
      let that = this;
      cordova.plugins.PowerOptimization.IsIgnoringBatteryOptimizations().then(
        (result) => {
          console.log(result);
          that.batteryOptimizationRemoved = result;
        },
        (err) => {
          console.error(err);
        }
      );
    },
  },
};
</script>

<style scoped>
/deep/ .card .card-body {
  padding: 15px;
  display: flex;
  align-items: center;
  padding: 1em;
}
</style>
